/* eslint-disable import/order */
import { Display } from 'src/services/responseTypes/singleLaunchResponse';
import { ContentLiteData, Genre } from 'src/types/consumption';
import { DynamicObject } from 'src/utils/commonTypes';
import { ASSET_SUBTYPE } from 'src/utils/constants/AppConstants';
import {
  gadarMovieID,
  karthikeyaMovieIds,
  kashmirFilesMovieIds,
  rakshaBandhanCollectionIds,
  rangbaazWebSeriesIds,
  rrrMovieIds,
  X_DEFAULT_HREF_LANG
} from 'src/utils/constants/CanonicalURLConstants';
import { MONTH_NAMES, MONTH_NAMES_FULL } from 'src/utils/constants/MonthNames';
import { NavMenuLinks } from 'src/utils/constants/RouterConstants';
import {
  CountryCode,
  DisplayLanguage,
  SHOWS
} from 'src/utils/constants/stringConstants';
import {
  CANONICAL_URLS,
  DISPLAY_LANGUAGE_LIST,
  FeatureFlagConstants,
  REMOTE_CONFIG,
  assetsForNoIndexNoFollow
} from 'src/utils/constants/utilConstants';
import { getURL } from 'src/utils/OGTags';
import { titleGenerator } from 'src/utils/routeHandler';

import {
  ConsumptionMetaDataObjectParams,
  MetaDataObject,
  SEOMetaObjectParams
} from './SEOMetaTypes';

//From: pageName.js
export const filterPathname = (pathName: string) => {
  const pathNameFiltered = pathName.split('/global');
  let newPathNameFiltered =
    pathNameFiltered.length === 1 ? pathNameFiltered[0] : pathNameFiltered[1];
  const isDisplayLang = DISPLAY_LANGUAGE_LIST.filter((lang) =>
    newPathNameFiltered.startsWith(`/${lang}`)
  );
  newPathNameFiltered =
    isDisplayLang.length > 0
      ? newPathNameFiltered.slice(3)
      : newPathNameFiltered;
  return newPathNameFiltered;
};

import {
  LANGUAGE_LABELS,
  LanguagesLabel,
  LanguagesLabels
} from '../../utils/languageConstants';
import { capitalizeFirstLetter } from '../../utils/TvShowDetailsHelper/tvShowDetailsHandler';
import { isSportsVOD } from '../MetaButtons/WatchlistBtn/WatchlistHandler';
import { ContentTypes } from '../thumbnail/types';
import { getDeviceWidth } from 'src/utils/getDeviceWidth';
import { TAG_NAME } from 'src/utils/constants/TagNameConstants';
import { getImageURL } from 'src/utils/ImageHelper/ImageURLGenerator';
import { isFeatureEnabled } from 'src/utils/RemoteConfig';
import { httpService } from 'src/services/fetch/HttpService';
import { SEO_API } from 'src/utils/constants/ApiConstants';
import { HTTP_METHODS } from 'src/utils/constants/HttpMethodsConstants';
import { buildUrlWithQueryParams } from 'src/utils/UrlGenerator';
import SimpleStore from 'src/store/SimpleStore';

export const newKeysList: object = {
  asset_subtype: 'assetSubType',
  app_cover: 'appCover',
  asset_type: 'assetType',
  audio_languages: 'audioLanguages',
  billing_type: 'billingType',
  business_type: 'businessType',
  content_owner: 'contentOwner',
  cover_image: 'coverImage',
  image_url: 'imageUrl',
  is_india_image_enabled: 'isIndiaImageEnabled',
  list_image: 'listImage',
  on_air: 'onAir',
  original_title: 'originalTitle',
  release_date: 'releaseDate',
  subtitile_language: 'subtitleLanguages',
  age_rating: 'ageRating',
  played_duration: 'playedDuration',
  episode_number: 'episodeNumber',
  total_page: 'totalPages',
  web_slug: 'webSlug',
  tvshow_details: 'tvShowDetails',
  seo_title: 'seoTitle',
  tvshow: 'tvShow',
  event_start_date: 'eventStartDate'
};

//common.js
export const getConsumptionMetaDataObj = ({
  item,
  z5Strings,
  translation,
  tag,
  isEpisode,
  showData,
  showDetail
}: ConsumptionMetaDataObjectParams) => {
  const displayLanguage = translation;
  if (
    !item ||
    !z5Strings ||
    !Object.keys(z5Strings).length ||
    !displayLanguage
  ) {
    return {};
  }
  const EPISODES_STRING = z5Strings.DETAILS.EPISODE;
  // const MOVIES_STRING =
  //   z5StringsEn &&
  //   Object.keys(z5StringsEn).length &&
  //   z5StringsEn.SEARCH_RESULT.MOVIES;
  const MOVIES_STRING = 'Movies';

  const languageLabels: LanguagesLabels = LANGUAGE_LABELS;
  let {
    audio_languages: audioLanguages,
    subtitle_languages: subtitleLanguages,
    release_date: releaseDate,
    genres,
    actors,
    duration
  } = item;
  // channels (for showDetail and episodeDetail pages)
  let channels;
  const {
    description,
    title,
    original_title: originalTitle,
    content_owner: contentOwner,
    episode_number: episodeNumber,
    age_rating: ageRating,
    extended,
    tvshow,
    tvshow_details: tvshowDetails,
    orderid: episodeOrder
  } = item;
  if (tag === SHOWS) {
    channels = item ? item.channels : null;
  } else {
    channels = tvshowDetails
      ? tvshowDetails.channels
      : showData && (showData.channels || null);
  }
  // music directors
  let musicDirectors = [];
  if (tag) {
    musicDirectors =
      extended && extended.music_directors ? extended.music_directors : null;
  } else {
    musicDirectors =
      tvshowDetails &&
      tvshowDetails.extended &&
      tvshowDetails.extended.musicDirectors
        ? tvshowDetails.extended.musicDirectors
        : (showData &&
            showData.extended &&
            showData.extended.music_directors) ||
          null;
  }
  // directors
  let directors = [];
  if (tag) {
    directors = item && item.directors ? item.directors : null;
  } else if (tvshowDetails && tvshowDetails.directors) {
    directors = tvshowDetails.directors;
  } else if (showData && showData.directors) {
    directors = showData.directors;
  } else if (showDetail && showDetail.directors) {
    directors = showDetail.directors;
  }
  let tvShowTitle = null;
  if (showData) {
    tvShowTitle =
      showData.title || showData.original_title
        ? showData.title || showData.original_title
        : null;
  } else {
    tvShowTitle =
      tvshow && (tvshow.title || tvshow.original_title)
        ? tvshow.title || tvshow.original_title
        : null;
  }
  // audio Languages
  const audioLanguagesEn =
    audioLanguages && Array.isArray(audioLanguages)
      ? audioLanguages.map((audioLanguage: string) => {
          const obj: DynamicObject = {};
          obj[languageLabels.en[audioLanguage as keyof LanguagesLabels]] =
            languageLabels[displayLanguage as keyof LanguagesLabels][
              audioLanguage as keyof LanguagesLabel
            ];
          return obj;
        })
      : null;
  audioLanguages =
    audioLanguages && Array.isArray(audioLanguages)
      ? audioLanguages.map(
          (audioLanguage) =>
            languageLabels[displayLanguage as keyof LanguagesLabels][
              audioLanguage as keyof LanguagesLabel
            ]
        )
      : null;
  audioLanguages =
    audioLanguages && audioLanguages.length
      ? audioLanguages.filter((audioLanguage: any) => !!audioLanguage)
      : null;
  // subtitle Languages
  subtitleLanguages =
    subtitleLanguages && Array.isArray(subtitleLanguages)
      ? subtitleLanguages.map(
          (subtitleLanguage) =>
            languageLabels[displayLanguage as keyof LanguagesLabels][
              subtitleLanguage as keyof LanguagesLabel
            ]
        )
      : null;
  subtitleLanguages =
    subtitleLanguages &&
    subtitleLanguages.filter((subtitleLanguage: any) => !!subtitleLanguage);
  // release date. if tag is "movies" or "shows", it should be year else complete date
  const date = releaseDate ? dateConversionObj(releaseDate) : null;
  if (date) {
    releaseDate =
      tag === MOVIES_STRING || tag === SHOWS
        ? date.year
        : `${date.day} ${date.month} ${date.year}`;
  }
  // genres
  const genresWithId = genres && Array.isArray(genres) ? genres : null;
  genres =
    genres && Array.isArray(genres) ? genres.map((genre) => genre.value) : null;
  // totalEpisodes across all seasons for "Shows" tag (ShowDetail page)
  let totalEpisodes = 0;
  if (tag === SHOWS) {
    if (item.seasons && Array.isArray(item.seasons)) {
      item.seasons.forEach((season: any) => {
        totalEpisodes += season.total_episodes;
      });
    }
  }
  // total seasons for Shows tag (only for showDetail page)
  let totalSeasons = 0;
  if (tag === SHOWS) {
    totalSeasons =
      item.seasons &&
      Array.isArray(item.seasons) &&
      (item.seasons[0].index || item.seasons[0].orderid);
  }
  // actors
  if (tag) {
    actors =
      actors && actors.length
        ? actors.map((actor: string) =>
            actor.split(':').map((actorWithSpace) => actorWithSpace.trim())
          )
        : null;
  } else if (
    tvshowDetails &&
    tvshowDetails.actors &&
    tvshowDetails.actors.length
  ) {
    actors = tvshowDetails.actors.map((actor: string) =>
      actor.split(':').map((actorWithSpace) => actorWithSpace.trim())
    );
  } else if (showData && showData.actors && showData.actors.length) {
    actors = showData.actors.map((actor: string) =>
      actor.split(':').map((actorWithSpace) => actorWithSpace.trim())
    );
  } else if (showDetail && showDetail.actors && showDetail.actors.length) {
    actors = showDetail.actors.map((actor: string) =>
      actor.split(':').map((actorWithSpace) => actorWithSpace.trim())
    );
  }
  // assetType
  const assetType =
    tag || `${EPISODES_STRING} ${episodeNumber || episodeOrder || 0}`;
  const episodeCount = isEpisode
    ? `E ${episodeNumber || episodeOrder || 0}`
    : null;
  // duration
  duration = duration ? timeConversion(duration) : null;
  // watch episode icon
  let showType;
  if (
    item.seasons &&
    Array.isArray(item.seasons) &&
    Object.keys(item.seasons).length &&
    Array.isArray(item.seasons[0].episodes) &&
    Object.keys(item.seasons[0].episodes).length &&
    item.seasons[0].episodes[0].episode_number === 1
  ) {
    showType = 'offAir';
  } else {
    showType = 'onAir';
  }
  return {
    audioLanguagesEn,
    audioLanguages,
    subtitleLanguages,
    releaseDate,
    genres,
    ageRating,
    actors,
    duration,
    channels,
    description,
    title,
    directors,
    originalTitle,
    contentOwner,
    musicDirectors,
    totalSeasons,
    totalEpisodes,
    assetType,
    tvShowTitle,
    showType,
    genresWithId,
    episodeCount
  };
};

//Conversion.js
export const getTimeIn24HourFormat = (time: string) => {
  if (time) {
    const hours = new Date(time).getHours();
    const minutes = new Date(time).getMinutes();
    return `${hours === 0 ? '00' : hours}:${minutes === 0 ? '00' : minutes}`;
  }
  return null;
};

export const timeConversion = (
  duration: number,
  minuteSecondFormatFlag = false
) => {
  const num = duration;
  if (typeof num === 'number') {
    if (num < 60) {
      return num < 0 ? '0s' : `${num}s`;
    }
    const hours = num / 3600;
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.floor(minutes);
    const rseconds =
      Math.floor((minutes - rminutes) * 60) === 0
        ? '00'
        : Math.floor((minutes - rminutes) * 60);
    // for Live tv card
    if (minuteSecondFormatFlag) {
      if (rhours > 0) {
        return `${rhours}h ${rminutes === 0 ? '00' : rminutes}m ${rseconds}s`;
      }
      return `${rminutes === 0 ? '00' : rminutes}m ${rseconds}s`;
    }

    if (rhours > 0 && rminutes > 0) {
      return `${rhours}h ${rminutes}m`;
    }
    if (rhours > 0) {
      return `${rhours}h`;
    }
    return `${rminutes}m`;
  }
  return '';
};

export const dateConversionObj = (date: string) => {
  const nullDateObject = {
    day: null,
    month: null,
    year: null,
    airedTime: null,
    fullMonthString: null
  };

  if (date) {
    const airedTime =
      date.toString().split('T').length > 1
        ? getTimeIn24HourFormat(date)
        : null;
    const dateObject = new Date(date);
    const day = dateObject.getDate();
    const month = MONTH_NAMES[dateObject.getMonth()];
    const fullMonthString = MONTH_NAMES_FULL[dateObject.getMonth()];
    const year = dateObject.getFullYear();
    if (Number.isNaN(day) || Number.isNaN(month) || Number.isNaN(year)) {
      return nullDateObject;
    }
    return {
      day,
      month,
      year,
      airedTime,
      fullMonthString
    };
  }
  return nullDateObject;
};

// global to check whether display langauge and country is RU and DE
export const isCountryDeOrRu = (
  countryCode: string,
  displayLanguage: string
) => {
  const globalSeoCondition =
    countryCode.toLocaleLowerCase() !== CountryCode.IN.toLowerCase() &&
    (displayLanguage === CountryCode.RU.toLowerCase() ||
      displayLanguage === CountryCode.DE.toLowerCase());
  return globalSeoCondition;
};
type ReplaceMetaDataType = {
  metaDataObj: MetaDataObject;
  languages: Display[];
  languageCode: string;
  replaceFromArray?: string[];
  replaceToArray?: string[];
  channel?: string;
  countryCode?: string;
  originalTitle?: string;
  contentPartnerName?: string;
  isConsupmptionPage?: boolean;
};
// Replace Meta data title and description
export const replaceMetaData = ({
  metaDataObj,
  languages,
  languageCode,
  replaceFromArray,
  replaceToArray,
  channel,
  countryCode,
  originalTitle,
  contentPartnerName,
  isConsupmptionPage
}: ReplaceMetaDataType) => {
  const metaData = { title: '', description: '', ...metaDataObj };
  if (!metaData.title) {
    metaData.title = '';
  }
  if (!metaData.description) {
    metaData.description = '';
  }
  if (!metaData.season) {
    metaData.season = '';
  }

  if (Object.keys(metaData).length) {
    if (metaData && replaceFromArray && replaceToArray) {
      for (let i = 0; i < replaceFromArray.length; i += 1) {
        //TODO: added explicit typecast, please confirm and update accordingly.
        let replaceTo = replaceToArray[i] as string;
        /**
         * Reference zee5.com . If match item is not exist it will replace to "-".
         * As per our discussion with barath
         */
        if (!replaceToArray[i]) {
          replaceTo = '-';
        }
        metaData.title = metaData.title.replace(
          new RegExp(`\\${replaceFromArray[i]}`, 'g'),
          replaceTo
        );

        metaData.description = metaData.description.replace(
          new RegExp(`\\${replaceFromArray[i]}`, 'g'),
          replaceTo
        );
      }
    }
    let languageName = '';
    if (languageCode !== 'en' && languages && languages.length > 0) {
      languageName = ` in ${getLanguage(languages, languageCode)}`;
    }
    metaData.title = metaData.title.replace(
      /<in {Regional Language}>/g,
      languageName
    );
    metaData.description = metaData.description.replace(
      /<in {Regional Language}>/g,
      languageName
    );
  }
  if (contentPartnerName && countryCode === 'US') {
    metaData.title = `${capitalizeFirstLetter(
      contentPartnerName
    )} - ${metaData.title
      .replace('on ZEE5', 'in USA on ZEE5')
      .replace('Serial', 'Show')}`;

    if (isConsupmptionPage) {
      metaData.description = `Watch your ${capitalizeFirstLetter(
        contentPartnerName
      )} favourite - ${replaceToArray?.[0]} ${
        replaceToArray?.[1]
      } Full Episode ${
        replaceToArray?.[6]
      } Online only in USA on ZEE5. Explore all the episodes of ${capitalizeFirstLetter(
        contentPartnerName
      )} special - ${replaceToArray?.[0]} TV Show in full HD with ZEE5 `;
    } else {
      metaData.description = `${capitalizeFirstLetter(
        contentPartnerName
      )} TV Show - Watch your favourite ${contentPartnerName} - ${
        replaceToArray?.[0]
      } TV Serial Online only in USA on ZEE5. Explore all the episodes for ${contentPartnerName} special - ${
        replaceToArray?.[0]
      } TV Show in full HD with ZEE5!`;
    }
  }
  if (channel && countryCode === 'US') {
    metaData.title = `${capitalizeFirstLetter(
      channel
    )} - ${metaData.title.replace('on ZEE5', 'in USA on ZEE5')}`;
    metaData.description = `Watch your ${capitalizeFirstLetter(
      channel
    )} favourite - ${originalTitle} movie streaming exclusively in USA on ZEE5. Explore your favourite ${channel} special moveis online in full HD with ZEE5 `;
  }
  return metaData;
};

export const getLanguage = (languages: Display[], languageCode: string) => {
  const contentRow = languages.find((lang) => lang.l_code === languageCode);
  return contentRow?.name ?? '';
};

export const getGenres = (genreArray: Genre[]) => {
  return genreArray?.map((genre) => genre.value).join(',');
};

// get Director or Actors
export const getDirectorOrActor = (data: string[]) => {
  return data ? data.join(',') : '';
};

// Extracts the real name for actors
export const getActorsName = (actors: string[]) => {
  const actorsList = actors
    ? actors?.map((actor) => actor.split(':')[0].trim())
    : [];
  return actorsList.join(', ');
};

// helper functions

export const getXDefaultLang = (
  id: string,
  isGlobalLanguages: boolean,
  isIndianLanguages: boolean,
  routerPath: string,
  country: string,
  episodeIndex = -1
) => {
  if (kashmirFilesMovieIds.includes(id)) {
    const hrefArray = [];
    if (isGlobalLanguages)
      hrefArray.push(X_DEFAULT_HREF_LANG.GLOBAL.KASHMIR_FILES);
    if (isIndianLanguages)
      hrefArray.push(X_DEFAULT_HREF_LANG.INDIA.KASHMIR_FILES);
    return hrefArray;
  } else if (rrrMovieIds.includes(id)) {
    return [X_DEFAULT_HREF_LANG.GLOBAL.RRR];
  } else if (karthikeyaMovieIds.includes(id)) {
    return [X_DEFAULT_HREF_LANG.GLOBAL.KARTHIKEYA];
  } else if (rangbaazWebSeriesIds.includes(id)) {
    return [X_DEFAULT_HREF_LANG.GLOBAL.RANGBAAZ];
  } else if (
    episodeIndex < 0 &&
    !kashmirFilesMovieIds.includes(id) &&
    !rrrMovieIds.includes(id) &&
    !karthikeyaMovieIds.includes(id) &&
    !rangbaazWebSeriesIds.includes(id) &&
    (isGlobalLanguages || isIndianLanguages)
  ) {
    return [
      getURL(
        country === CountryCode.IN.toLowerCase()
          ? CountryCode.IN.toLowerCase()
          : CountryCode.GB.toLowerCase(),
        'en',
        routerPath
      )
    ];
  }
  return [];
};

const { GERMAN, RUSSIAN, ENGLISH } = DisplayLanguage;
const { IN, GB, US } = CountryCode;

export const isGetSEOThroughApiEnabled = () => {
  const remoteConfig = SimpleStore.get(REMOTE_CONFIG);
  return isFeatureEnabled(
    remoteConfig,
    FeatureFlagConstants.FEATURE_SEO_THROUGH_API
  );
};

const isLogicalPath = (path: string) => {
  const logicalPaths = [
    /^\/movies\/year$/, // /movies/year
    /^\/movies\/year\/\d+$/, // /movies/year/:yearNumb
    /^\/movies\/lang\/[^/]+\/[^/]+$/, // /movies/lang/:langName/:categoryType
    /^\/movies\/lang\/[^/]+$/, // /movies/lang/:languageName
    new RegExp(`^/${process.env.TVSHOWS}/lang/[^/]+$`), // /${process.env.TVSHOWS}/lang/:languageName
    new RegExp(`^/${process.env.ZEE5ORIGINALS}/lang/[^/]+$`), // /${process.env.ZEE5ORIGINALS}/lang/:languageName
    new RegExp(`^/${process.env.TVSHOWS}/genre/[^/]+$`), // /${process.env.TVSHOWS}/genre/:genreName
    new RegExp(`^/${process.env.ZEE5ORIGINALS}/genre/[^/]+$`), // /${process.env.ZEE5ORIGINALS}/genre/:genreName
    new RegExp(`^/${process.env.ZEE5ORIGINALS}/genre/[^/]+/[^/]+$`), // /${process.env.ZEE5ORIGINALS}/genre/:genreName/:languageName
    new RegExp(`^/${process.env.TVSHOWS}/genre/[^/]+/[^/]+$`), // /${process.env.TVSHOWS}/genre/:genreName/:languageName
    /^\/movies\/genre\/[^/]+\/[^/]+$/, // /movies/genre/:genreName/:langName
    /^\/movies\/genre\/[^/]+$/ // /movies/genre/:genreName
  ];
  return logicalPaths.some((pattern) => pattern.test(path));
};

const getTextType = (path: string) => {
  const pathArray = path.split('/').filter(Boolean);
  return pathArray.join('_');
};

/**
 * Loads the static seo json file.
 * @param countryCode
 * @param displayLanguage
 * @returns loaded json as object
 */
export const getSeoData = async (
  //retrieves seo data from api/local json
  countryCode: string,
  displayLanguage: string,
  path?: string
) => {
  if (isGetSEOThroughApiEnabled() && path && isLogicalPath(path)) {
    //if feature is enabled & path is logical, then call api and return the data
    const url = buildUrlWithQueryParams(SEO_API, {
      ccode: countryCode,
      text_type: getTextType(path),
      lang: displayLanguage
    });

    return await httpService.fetchApiData({ url: url, type: HTTP_METHODS.GET });
  } else {
    const seoMetaAssets = await import(
      `../../../public/webapp-assets/json/seo_meta.json?appversion=${process.env.APP_VERSION}`
    ).then((res) => res.default);

    if (countryCode === IN) {
      return seoMetaAssets;
    }

    const staticGlobalSEOMeta = await import(
      `../../../public/webapp-assets/json/seo_global_meta.json?appversion=${process.env.APP_VERSION}`
    ).then((res) => res.default);

    const assets =
      displayLanguage === GERMAN || displayLanguage === RUSSIAN
        ? staticGlobalSEOMeta[displayLanguage]
        : seoMetaAssets;

    return { ...assets, ...staticGlobalSEOMeta[ENGLISH] };
  }
};

//TODO: add for other pages
export const getSeoUrlForMovies = (pathName: string, country: string) => {
  if (pathName.includes('/add-ons')) {
    return '/add-ons/movies/consumption';
  }
  if (pathName.includes('/movies/details/friends-the-reunion/0-0-417628'))
    return '/movies/details/friends-the-reunion/0-0-417628';

  if (pathName.includes('/movies/details/friends-the-reunion/0-0-417983'))
    return '/movies/details/friends-the-reunion/0-0-417983';

  if (pathName.includes('/movies/details/wanted/0-0-2463') && country !== IN)
    return country !== GB && country !== US
      ? '/movies/details/wanted/0-0-2463'
      : '/movies/details/wanted/0-0-2463UK';

  if (
    pathName.includes('/movies/details/writer-padmabhushan/0-0-1z5323051') &&
    country !== 'IN'
  )
    return country !== GB && country !== US
      ? '/movies/details/writer-padmabhushan/0-0-1z5323051'
      : '/movies/details/writer-padmabhushan/0-0-1z5323051UK';
  if (pathName.includes('/movies/details')) return '/movies/details';

  return '/movies/details';
};

const getSeoUrlForEpisodes = (
  assetSubtype: string,
  seasonTitle: string,
  pathName: string
) => {
  let metaUrl = '';
  const ZEE5ORIGINALS = process.env.NEXT_PUBLIC_ZEE5ORIGINALS;
  const KIDSSHOWS = 'kids-shows';
  const regExpOrig = new RegExp(`${ZEE5ORIGINALS}`, 'g');
  const regExpKids = new RegExp(`${KIDSSHOWS}`, 'g');
  if (pathName.match(regExpOrig)) {
    if (pathName.includes('add-ons')) {
      metaUrl = '/add-ons/web-series/consumption';
    } else if (assetSubtype === ASSET_SUBTYPE.TRAILER) {
      if (seasonTitle === 'Season 1') {
        metaUrl = `/${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}/showDetailsTrailer`;
      } else {
        metaUrl = `/${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}/multiSeasonTrailer`;
      }
    } else if (
      assetSubtype === ASSET_SUBTYPE.EPISDOE ||
      assetSubtype === ASSET_SUBTYPE.ORIGINALS
    ) {
      metaUrl = `/${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}/episodes`;
    } else {
      metaUrl = `/${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}/showDetails`;
    }
  } else if (pathName.match(regExpKids)) {
    metaUrl = '/kids/kids-shows-details';
  } else if (
    isSportsVOD({
      path: pathName
    })
  ) {
    metaUrl = '/ilt20/sports-vod';
  } else if (
    pathName.includes('add-ons') &&
    pathName.includes('tv-shows/details')
  ) {
    metaUrl = '/add-ons/tv-shows/consumption';
  } else {
    switch (assetSubtype) {
      case ASSET_SUBTYPE.TRAILER:
        metaUrl = `/${process.env.NEXT_PUBLIC_TVSHOWS}/showDetailsTrailer`;
        break;
      case ASSET_SUBTYPE.PREVIEW:
        metaUrl = `/${process.env.NEXT_PUBLIC_TVSHOWS}/showDetailsSpoiler`;
        break;
      case ASSET_SUBTYPE.WEBISODE:
        metaUrl = `/${process.env.NEXT_PUBLIC_TVSHOWS}/showDetailsWebisode`;
        break;
      case ASSET_SUBTYPE.CLIP:
        metaUrl = `/${process.env.NEXT_PUBLIC_TVSHOWS}/showDetailsBestScene`;
        break;
      case ASSET_SUBTYPE.PROMO:
        metaUrl = `/${process.env.NEXT_PUBLIC_TVSHOWS}/showDetailsPromo`;
        break;
      case ASSET_SUBTYPE.MOBISODE:
        metaUrl = `/${process.env.NEXT_PUBLIC_TVSHOWS}/showDetailsMobisode`;
        break;
      case ASSET_SUBTYPE.WEEKINSHORT:
        metaUrl = `/${process.env.NEXT_PUBLIC_TVSHOWS}/showDetailsWeekInShort`;
        break;
      default:
        metaUrl = `/${process.env.NEXT_PUBLIC_TVSHOWS}/showDetails`;
        break;
    }
  }
  return metaUrl;
};

export const getSEOMetaObject = ({
  contentLightResponse,
  assetID
}: SEOMetaObjectParams) => {
  const seoMetaObject = {
    isIndia: false,
    isGlobal: false,
    noIndexNoFollow: false
  };

  if (contentLightResponse && Object.keys(contentLightResponse).length) {
    const { error_code: errorCode = '' } = contentLightResponse;
    if (errorCode && errorCode === 101) {
      seoMetaObject.isGlobal = false;
      seoMetaObject.isIndia = false;
    } else {
      if (contentLightResponse.licensing) {
        seoMetaObject.isGlobal =
          contentLightResponse.licensing?.isAvailableGlobal;
        seoMetaObject.isIndia =
          contentLightResponse.licensing?.isAvailableIndia;
      }
    }
    seoMetaObject.noIndexNoFollow = false;
  }

  if (assetID.match(assetsForNoIndexNoFollow)) {
    seoMetaObject.noIndexNoFollow = true;
  }
  return seoMetaObject;
};

const getEpisodeAssetTypeBreadcrumbLabel = (
  item: ContentLiteData,
  z5Strings: DynamicObject
) => {
  if (item && item.asset_subtype) {
    switch (item.asset_subtype) {
      case ASSET_SUBTYPE.CLIP:
        return item.title;
      case ASSET_SUBTYPE.TRAILER:
        return z5Strings.BREADCRUMB.TRAILER;
      case ASSET_SUBTYPE.PREVIEW:
        return `${z5Strings.BREADCRUMB.PREVIEW} ${
          item.episode_number ?? item.episodeNumber ?? item.orderid
        }`;
      case ASSET_SUBTYPE.WEBISODE:
        return `${z5Strings.BREADCRUMB.WEBISODE} ${
          item.episode_number ?? item.episodeNumber ?? item.orderid
        }`;
      case ASSET_SUBTYPE.PROMO:
      case ASSET_SUBTYPE.EPISDOE:
      case ASSET_SUBTYPE.TV_SHOW:
      case ASSET_SUBTYPE.ORIGINALS:
        return `${z5Strings?.DETAILS.EPISODE} ${
          item.episode_number ?? item.episodeNumber ?? item.orderid
        }`;
      default:
        return item.asset_subtype;
    }
  }
  return item.title;
};

export const getBreadCrumbs = (item: DynamicObject) => {
  const {
    contentLiteData,
    consumptionPageTranslations,
    pageDetails,
    isKidsData,
    router,
    contentTitle,
    showName,
    showId
  } = item;
  switch (pageDetails.contentType) {
    case ContentTypes.movies:
      return [
        {
          label: consumptionPageTranslations?.BREADCRUMB.MOVIES,
          url: `${isKidsData ? NavMenuLinks.KIDS : NavMenuLinks.MOVIES}`
        },
        {
          label:
            contentLiteData && Object.keys(contentLiteData).length > 0
              ? contentTitle
              : null,
          url: router.asPath
        }
      ];
    case ContentTypes.tvshows:
    case ContentTypes.webSeries:
      if (isKidsData) {
        return [
          {
            label: consumptionPageTranslations?.BREADCRUMB.KIDS,
            url: NavMenuLinks.KIDS
          },
          {
            label: showName,
            url: `/kids/kids-shows/${titleGenerator(showName)}/${showId}`
          },
          {
            label: contentTitle,
            url: router?.asPath
          }
        ];
      } else {
        return [
          {
            label:
              pageDetails.contentType === ContentTypes.tvshows
                ? consumptionPageTranslations?.BREADCRUMB.SHOWS
                : consumptionPageTranslations?.BREADCRUMB.ZEEORIGINALS,
            url:
              pageDetails.contentType === ContentTypes.tvshows
                ? `/${process.env.NEXT_PUBLIC_TVSHOWS}`
                : `/${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}`
          },
          {
            label: showName,
            url:
              pageDetails.contentType === ContentTypes.tvshows
                ? `/${
                    process.env.NEXT_PUBLIC_TVSHOWSCONSUMPTION
                  }/${titleGenerator(showName)}/${showId}`
                : `/${
                    process.env.NEXT_PUBLIC_ZEE5ORIGINALSCONSUMPTION
                  }/${titleGenerator(showName)}/${showId}`
          },
          {
            label:
              contentLiteData &&
              getEpisodeAssetTypeBreadcrumbLabel(
                contentLiteData,
                consumptionPageTranslations
              ),
            url: router?.asPath
          }
        ];
      }
    case ContentTypes.celebs:
      return [
        {
          label: contentTitle,
          url: router.asPath
        }
      ];
    case ContentTypes.filmography:
      return [
        {
          label: contentTitle,
          url: router.asPath
        }
      ];
    default:
      return [];
  }
};

export const getPersonSchema = (item: DynamicObject) => {
  const { celebrityDetails, router } = item;
  let personSchema = {};

  if (celebrityDetails) {
    personSchema = {
      name: celebrityDetails.name,
      url: router.asPath,
      image: getImageURL({
        deviceWidth: getDeviceWidth() || 0,
        tagName: TAG_NAME.BANNER,
        item: {
          id: celebrityDetails.id,
          title: celebrityDetails.name,
          image: celebrityDetails.image
        }
      }),
      jobTitle: celebrityDetails.castTypes
    };
  }
  return personSchema;
};
export const getHeaderForSEO = (
  contentLiteData: ContentLiteData,
  contentType: string
) => {
  switch (contentType) {
    case ContentTypes.movies:
      return `Details About ${contentLiteData?.title} Movie: `;
    case ContentTypes.tvshows:
    case ContentTypes.webSeries:
      return `Details About ${contentLiteData?.tvshow_name} Show: `;
    default:
      return `Details About ${contentLiteData?.title}: `;
  }
};

export const getSeoUrl = (
  contentType: string,
  pathName: string,
  countryCode: string,
  isLatestRoute?: boolean,
  isLatest1Route?: boolean,
  contentLiteData?: DynamicObject,
  isKidsData?: boolean
) => {
  if (contentType === ContentTypes.movies) {
    if (isKidsData) {
      return '/kids/kids-movies';
    }
    return getSeoUrlForMovies(pathName, countryCode);
  } else if (contentType === ContentTypes.celebs) {
    return '/celebs';
  } else if (contentType === ContentTypes.filmography) {
    return '/filmography';
  } else {
    if (isLatestRoute || isLatest1Route) {
      const ZEE5ORIGINALS = process.env.NEXT_PUBLIC_ZEE5ORIGINALS;
      const KIDSSHOWS = 'kids-shows';
      const regExpOrig = new RegExp(`${ZEE5ORIGINALS}`, 'g');
      const regExpKids = new RegExp(`${KIDSSHOWS}`, 'g');
      if (pathName.match(regExpOrig)) {
        return `/${ZEE5ORIGINALS}/showDetails`;
      } else if (pathName.match(regExpKids)) {
        return '/kids/kids-shows-details';
      } else {
        return `/${process.env.NEXT_PUBLIC_TVSHOWS}/showDetails`;
      }
    } else {
      return getSeoUrlForEpisodes(
        contentLiteData?.asset_subtype || '',
        contentLiteData?.season_details?.[0]?.title || '',
        pathName
      );
    }
  }
};
export const getCanonicalLink = (
  id: string,
  collectionPageId: string,
  ogUrl: string,
  countryCode: string
) => {
  if (!ogUrl) return '';

  const isMoviePage =
    ogUrl.includes('/movies') && !ogUrl.includes('/movies/all');
  const isZEE5OriginalsPage =
    ogUrl.includes(`/${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}`) &&
    !ogUrl.includes(`${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}/all`) &&
    !ogUrl.includes('/latest');
  const isKidsPage =
    ogUrl.includes('/kids') &&
    !ogUrl.includes('/kids/all') &&
    !ogUrl.includes('/latest');
  const isTVShowsPage =
    ogUrl.includes(`/${process.env.NEXT_PUBLIC_TVSHOWS}`) &&
    !ogUrl.includes(`${process.env.NEXT_PUBLIC_TVSHOWS}/all`) &&
    !ogUrl.includes('/latest');

  const generalPageCondition =
    isMoviePage ||
    isZEE5OriginalsPage ||
    isKidsPage ||
    isTVShowsPage ||
    ogUrl.includes('/movies/premium') ||
    ogUrl.includes('/movies/popular') ||
    ogUrl.includes('/movies/new-movies') ||
    ogUrl.includes('/movies/trending') ||
    ogUrl.includes('/movies/free') ||
    ogUrl.includes('/movies/hollywood-movies') ||
    ogUrl.includes('/movies/south-movies') ||
    ogUrl.includes('/movies/details') ||
    ogUrl.includes('/movies/lang') ||
    ogUrl.includes('/movies/genre') ||
    ogUrl.includes('/movies/year') ||
    ogUrl.includes('/movies/celeb') ||
    ogUrl.includes('/celebs') ||
    ogUrl.includes('/filmography') ||
    ogUrl.includes('/movies/bollywood') ||
    ogUrl.includes('/movies/bollywood/latest-release') ||
    ogUrl.includes('/movies/bollywood/popular') ||
    ogUrl.includes('/movies/bollywood/trending') ||
    ogUrl.includes('/movies/zee5-exclusive') ||
    ogUrl.includes('/movies/zee5-originals') ||
    ogUrl.includes(`/${process.env.NEXT_PUBLIC_LIVETV}`) ||
    ogUrl.includes(`/${process.env.NEXT_PUBLIC_CHANNELCONSUMPTION}`) ||
    ogUrl.includes('/news') ||
    ogUrl.includes('/kids/kids-shows') ||
    ogUrl.includes('/kids/kids-movies') ||
    ogUrl.includes('/kids/kids-videos') ||
    ogUrl.includes('/zeekannada/news') ||
    ogUrl.includes('/upcoming') ||
    ogUrl.includes('/free-movies') ||
    ogUrl.includes('/play5-games') ||
    ogUrl.includes('/live-tv') ||
    ogUrl.includes('/live-tv/genre') ||
    ogUrl.includes('/live-tv/lang') ||
    ogUrl.includes('/live-tv/lang-genre') ||
    ogUrl.includes('/live-tv/free-channels') ||
    ogUrl.includes('/live-tv/premium-channels') ||
    ogUrl.includes('/live-tv/news-channels') ||
    ogUrl.includes('/live-tv/all') ||
    ogUrl.includes('/collections') ||
    ogUrl.includes('/myaccount/subscription') ||
    ogUrl.includes('/') ||
    ogUrl.includes('/club-pack') ||
    ogUrl.includes('/collections') ||
    ogUrl.includes('/zee-plex-movies-on-rent') ||
    ogUrl.includes('/club-pack') ||
    ogUrl.includes('/premium') ||
    ogUrl.includes('/music-videos') ||
    ogUrl.includes('/videos') ||
    ogUrl.includes('/register') ||
    ogUrl.includes('/sign-in') ||
    ogUrl.includes('/aboutus') ||
    ogUrl.includes('/termsofuse') ||
    ogUrl.includes('/privacypolicy') ||
    ogUrl.includes('/settings') ||
    ogUrl.includes('/settings');

  const isGadarIndia =
    id && gadarMovieID.includes(id) && countryCode === CountryCode.IN;
  const isIdNotInSpecialCase = [
    !rrrMovieIds.includes(id),
    !karthikeyaMovieIds.includes(id),
    !rangbaazWebSeriesIds.includes(id),
    !rakshaBandhanCollectionIds.includes(collectionPageId),
    !isGadarIndia
  ].reduce((a, b) => a && b, true);

  if (isIdNotInSpecialCase && generalPageCondition) {
    return ogUrl;
  }

  const indiaOrGlobal = countryCode !== CountryCode.IN ? 'GLOBAL' : 'INDIA';
  //TODO: Single object for special cases
  if (rrrMovieIds.includes(id)) return CANONICAL_URLS[indiaOrGlobal].RRR;
  if (karthikeyaMovieIds.includes(id))
    return CANONICAL_URLS[indiaOrGlobal].KARTHIKEYA;
  if (rakshaBandhanCollectionIds.includes(collectionPageId))
    return CANONICAL_URLS[indiaOrGlobal].RAKSHA_BANDHAN;
  if (rangbaazWebSeriesIds.includes(id))
    return CANONICAL_URLS[indiaOrGlobal].RANGBAAZ;
  if (isGadarIndia) return CANONICAL_URLS.INDIA.GADAR;
  return '';
};

export const getSeoContent = async (path: string) => {
  const seoContent = await import(
    `../../../public/webapp-assets/json/seo_content.json?appversion=${process.env.APP_VERSION}`
  ).then((res) => res.default);

  return seoContent;
};
